import React, { FC, useEffect, useState } from 'react';
import { BlogArticleFragment } from '../../../../../__generated__/gatsby-types';
import SpotlightCard from '../../../spotlight-card';
import ArticleCard from '../../../article-card';
import { Box, createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PgeButton from '../../../../pge-button/_PgeButton';
import SocialFollowLinks from '../../../social-follow-links';
import { useTranslation } from '../../../../../hooks/useTranslation';
import colors from '../../../../../themes/main-colors';

const useStyles = makeStyles(() =>
  createStyles({
    articles: {
      display: 'flex',
      flexDirection: 'column',
      gap: '30px',
    },
    columnBox: {
      display: 'flex',
      flexDirection: 'column',
      gap: '30px',
    },
    hr: {
      margin: '30px 0',
      color: colors.lightGray1,
      backgroundColor: colors.lightGray1,
      borderColor: colors.lightGray1,
      borderStyle: 'solid',
    },
    showMoreButton: {
      width: '80%',
      fontWeight: 600,
    },
  }),
);

interface Props {
  articles: BlogArticleFragment[];
  spotlightArticle?: BlogArticleFragment;
}

const Mobile: FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { articles, spotlightArticle } = props;
  const hasSpotlightArticle = !!spotlightArticle?.id;

  const articlesToShowOnload = 5;

  const [articelColumn, setArticleColumn] = useState<BlogArticleFragment[]>([]);
  const [isShowMoreButtonDisplayed, setIsShowMoreButtonDisplayed] = useState(
    false,
  );
  const [nextArticle, setNextArticle] = useState<number>(articlesToShowOnload);

  useEffect(() => {
    if (articles && articles?.length > 0) {
      const articlesToShow = articles.slice(
        0,
        hasSpotlightArticle ? articlesToShowOnload - 1 : articlesToShowOnload,
      );

      // If a Spotlight Article exists, take it out of the flow and pin it
      // as the third item.
      if (hasSpotlightArticle) {
        articlesToShow.splice(2, 0, spotlightArticle);
      }

      setArticleColumn(articlesToShow);

      setIsShowMoreButtonDisplayed(
        (hasSpotlightArticle
          ? articlesToShowOnload - 1
          : articlesToShowOnload) < articles.length,
      );
    }
  }, []);

  const handleLoadMoreArticles = () => {
    let articelColumnUpdate: BlogArticleFragment[] = [];

    const newArticleIndex = nextArticle + 5;
    const moreArticles = articles.slice(nextArticle, newArticleIndex);

    articelColumnUpdate = articelColumn.concat(moreArticles);

    setArticleColumn(articelColumnUpdate);
    setNextArticle(newArticleIndex);
    setIsShowMoreButtonDisplayed(newArticleIndex < articles.length);
  };

  return (
    <>
      <Box className={classes.articles}>
        <Box className={classes.columnBox}>
          {articelColumn.map((item: BlogArticleFragment, index: number) =>
            hasSpotlightArticle && index === 2 ? (
              <SpotlightCard item={item} />
            ) : (
              <ArticleCard item={item} />
            ),
          )}
        </Box>
      </Box>
      <hr className={classes.hr} />
      <Box
        display={'flex'}
        justifyContent={
          isShowMoreButtonDisplayed ? 'space-between' : 'flex-end'
        }
        flexDirection={'column'}
        alignItems={'center'}
        mt={2.5}
        mb={2.5}
      >
        {isShowMoreButtonDisplayed ? (
          <PgeButton
            className={classes.showMoreButton}
            theme="Secondary"
            onClick={handleLoadMoreArticles}
          >
            {t('SHOW_MORE')}
          </PgeButton>
        ) : null}
        <SocialFollowLinks />
      </Box>
    </>
  );
};

export default Mobile;
